(function () {
  'use strict';
  if (window.jfnCart && window.jfnCart.v) { return; }
  var d = document, html = d.documentElement;
  var scr = d.querySelector('script[data-jfnc-script]');
  var SECTION = (scr && scr.getAttribute('data-section')) || 'jfn-cart-drawer';
  var R = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var IOS = /iP(hone|ad|od)/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var root, panel, last, isOpen = false, lockY = 0, toastT, queue = Promise.resolve(), timers = {}, selfEmit = false, selfAdded = false;
  var lastHtml = '', lastChanged = true, buildMute = 0, idle = 0, lastSync = 0, inflight = null, again = false, pending = false, pendingT, cpOpen = false;
  var fillAt = 0, addFill = null, nativeFetch = window.fetch, seq = 0, applied = 0;
  var q = function (s, r) { return (r || d).querySelector(s); };
  var qa = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var roots = function () { return qa('[data-jfnc-root]'); };
  var fire = function (n, detail) { d.dispatchEvent(new CustomEvent(n, { detail: detail || {} })); };
  var url = function (p) { return R + p; };

  /* tekstovi dolaze iz Liquida (DE/EN) preko data-t na .jfnc__fill; JS nema vlastitih jezicnih tekstova */
  function tr(k) { var f = q('.jfnc__fill'), o = {}; try { o = JSON.parse((f && f.getAttribute('data-t')) || '{}'); } catch (e) {} return o[k] || ''; }
  function say(t) { var l = q('.jfnc__live', root); if (l) { l.textContent = ''; setTimeout(function () { l.textContent = t; }, 30); } }
  function toast(t) {
    var host = root || q('[data-jfnc-root]'); if (!host) { return; }
    var el = q('.jfnc__toast', host);
    if (!el) { el = d.createElement('div'); el.className = 'jfnc__toast'; el.setAttribute('role', 'alert'); (q('.jfnc__panel', host) || host).appendChild(el); }
    el.textContent = t; el.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { el.classList.remove('is-on'); }, 4500);
  }
  var atcBtn = null;
  function btnLoad(on, b) { /* spinner na gumbu "In den Warenkorb" dok drawer nema prave podatke; dimenzije se ne mijenjaju */
    try {
      if (on && b) { if (atcBtn && atcBtn !== b) { atcBtn.classList.remove('jfnc-atc-load'); } atcBtn = b; b.style.setProperty('--jfnc-spin', getComputedStyle(b).color || '#fff'); b.classList.add('jfnc-atc-load'); }
      else if (!on && atcBtn) { atcBtn.classList.remove('jfnc-atc-load'); atcBtn.style.removeProperty('--jfnc-spin'); atcBtn = null; }
    } catch (e) {}
  }
  function adding(on) { qa('.jfnc__fill').forEach(function (el) { el.classList.toggle('is-adding', on); }); if (!on) { optClear(); btnLoad(false); } }
  function busy(on) { qa('.jfnc__fill').forEach(function (el) { el.classList.toggle('is-busy', on); el.setAttribute('aria-busy', on ? 'true' : 'false'); }); }

  /* OPTIMISTICKI REDAK: odmah po kliku na "In den Warenkorb" prikazi stavku iz podataka proizvoda (/products/<handle>.js, ~100 ms, kesira se i grije na pointerdown)
     umjesto sivog skeletona koji je trajao dok ne zavrse Fee-Rules (Pfand) provjera + dva /cart/add.js. Prava kosarica ga zamjenjuje cijelog (swap -> novi .jfnc__fill). */
  var prodCache = {}, optToken = 0;
  function fmtMoney(c) {
    try { return new Intl.NumberFormat(d.documentElement.lang || 'de-DE', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(c / 100); }
    catch (e) { return (c / 100).toFixed(2) + ' \u20ac'; }
  }
  function handlesFor(form) { /* kandidati po redu; prva stranica proizvoda koja sadrzi trazenu varijantu pobjedjuje */
    var out = [], add = function (h) { if (h && out.indexOf(h) < 0) { out.push(h); } };
    var host = form.closest('[data-product-handle],[data-handle]');
    if (host) { add(host.getAttribute('data-product-handle') || host.getAttribute('data-handle')); }
    var node = form;
    for (var i = 0; node && i < 8; i++, node = node.parentNode) {
      var a = node.querySelector && node.querySelector('a[href*="/products/"]');
      if (a) { var mm = (a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/); if (mm) { add(mm[1]); break; } }
    }
    var m = location.pathname.match(/\/products\/([^\/?#]+)/); if (m) { add(m[1]); }
    return out;
  }
  function findProd(form, vid) {
    var hs = handlesFor(form), k = 0;
    function next() {
      if (k >= hs.length) { return Promise.resolve(null); }
      return getProd(hs[k++]).then(function (p) { return p && (p.variants || []).some(function (x) { return String(x.id) === vid; }) ? p : next(); });
    }
    return next();
  }
  function getProd(handle) {
    if (!handle) { return Promise.resolve(null); }
    if (!prodCache[handle]) { prodCache[handle] = nativeFetch.call(window, R + 'products/' + handle + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }
    return prodCache[handle];
  }
  function optClear() { qa('.jfnc-ci--opt,.jfnc-ci--gap').forEach(function (e) { e.remove(); }); qa('.jfnc__fill.has-opt').forEach(function (e) { e.classList.remove('has-opt'); }); }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function optimistic(form) {
    var tok = ++optToken;
    try {
      var fd = new FormData(form), vid = String(fd.get('id') || ''), qty = parseInt(fd.get('quantity'), 10) || 1, plan = fd.get('selling_plan');
      if (!vid) { return; }
      var fill = q('.jfnc__fill');
      var ex = fill && qa('.jfnc-ci', fill).filter(function (a) { return a.getAttribute('data-vid') === vid; })[0];
      if (ex) { // varijanta je vec u kosarici: samo pokazi veci broj
        var inp = q('.jfnc-q__i', ex); if (inp) { inp.value = (parseInt(inp.value, 10) || 0) + qty; fill.classList.add('has-opt'); }
        return;
      }
      findProd(form, vid).then(function (p) {
        if (tok !== optToken || !p || !(pending || isOpen)) { return; }
        var v = (p.variants || []).filter(function (x) { return String(x.id) === vid; })[0];
        if (!v) { return; }
        var img = (v.featured_image && v.featured_image.src) || p.featured_image || '';
        if (img) { img = img + (img.indexOf('?') < 0 ? '?' : '&') + 'width=160'; }
        var price = '';
        if (!plan) { price = (v.compare_at_price && v.compare_at_price > v.price ? '<del>' + fmtMoney(v.compare_at_price * qty) + '</del> ' : '') + '<ins>' + fmtMoney(v.price * qty) + '</ins>'; }
        var meta = v.title && v.title !== 'Default Title' ? '<div class="jfnc-ci__meta">' + esc(v.title) + '</div>' : '';
        var html = '<article class="jfnc-ci jfnc-ci--opt" aria-hidden="true"><span class="jfnc-ci__img">' + (img ? '<img class="jfnc-ci__im" src="' + esc(img) + '" width="60" height="60" alt="">' : '') + '</span>'
          + '<div class="jfnc-ci__main"><span class="jfnc-ci__name">' + esc(p.title) + '</span>' + meta
          + '<div class="jfnc-ci__row"><span class="jfnc-ci__qty1">' + qty + ' &times;</span><div class="jfnc-ci__price">' + price + '</div></div></div></article>';
        /* BF 1.11.2026.: odmah i 3 poklona (isti izgled kao prava kosarica) da se kosarica ne slaze u 3 koraka */
        var gh0 = fill ? (fill.getAttribute('data-gh') || '') : '';
        if (Date.now() < 1796079599000 && BF_GIFTS.some(function (g) { return gh0.indexOf('|' + g + '|') < 0; })) {
          var de = !/^en/i.test(d.documentElement.lang || 'de'), gl = de ? 'Geschenk zu deiner Bestellung' : 'Gift with your order', fr = de ? 'KOSTENLOS' : 'FREE';
          BF_OPT.forEach(function (g) {
            html += '<article class="jfnc-ci jfnc-ci--opt" aria-hidden="true"><span class="jfnc-ci__img"><img class="jfnc-ci__im" src="' + g[2] + '&width=160" width="60" height="60" alt=""></span>'
              + '<div class="jfnc-ci__main"><span class="jfnc-ci__name">' + esc(g[0]) + '</span><div class="jfnc-ci__meta jfnc-ci__gift">' + gl + '</div>'
              + '<div class="jfnc-ci__row"><div class="jfnc-ci__price"><del>' + fmtMoney(g[1]) + '</del> <ins class="jfnc-free">' + fr + '</ins></div></div></div></article>';
          });
        }
        qa('.jfnc__fill').forEach(function (f) {
          if (!f.classList.contains('is-adding') || q('.jfnc-ci--opt', f)) { return; }
          var sc = q('.jfnc__scroll', f); if (!sc) { return; }
          var skb = q('.jfnc-bar--sk', sc); if (skb) { skb.insertAdjacentHTML('afterend', (f.classList.contains('is-empty') ? '<div class="jfnc-ci--gap" aria-hidden="true"></div>' : '') + html); f.classList.add('has-opt'); return; }
          sc.insertAdjacentHTML('afterbegin', (f.classList.contains('is-empty') ? '<div class="jfnc-ci--gap" aria-hidden="true"></div>' : '') + html); f.classList.add('has-opt');
        });
      });
    } catch (e) {}
  }
  d.addEventListener('pointerdown', function (e) { var f = e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]'); if (f && root) { var fid = f.querySelector('[name="id"]'); atcAt = Date.now(); findProd(f, fid ? String(fid.value) : ''); ssWarm(fid ? String(fid.value) : ''); } }, true);
  d.addEventListener('change', function (e) { var f = e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]'); if (f) { var fid = f.querySelector('[name="id"]'); if (fid) { ssWarm(String(fid.value)); } } }, true);
  if (d.readyState === 'complete') { setTimeout(ssWarmPage, 1500); } else { window.addEventListener('load', function () { setTimeout(ssWarmPage, 1500); }); }

  function parse(h) {
    var t = d.createElement('template'); t.innerHTML = h;
    return t.content.querySelector('.jfnc__fill');
  }
  function forPage(h) { // isti sadrzaj bez zaglavlja drawera, jedinstveni id-evi
    return h.replace(/(jfnc-cp-body|jfnc-checkout)-drawer/g, '$1-page');
  }
  function swap(h, sq) {
    if (!h) { return false; }
    if (sq) { if (sq < applied) { return false; } applied = sq; } /* odgovor starijeg zahtjeva ne smije pregaziti noviji */
    var changed = h !== lastHtml;
    lastHtml = h; lastSync = Date.now(); lastChanged = changed;
    if (!changed) { return true; } /* isti sadrzaj: bez zamjene DOM-a (nema treperenja) */
    var first = null;
    roots().forEach(function (r) {
      var cur = q('.jfnc__fill', r); if (!cur) { return; }
      var page = r.getAttribute('data-jfnc-mode') === 'page';
      var nf = parse(page ? forPage(h) : h); if (!nf) { return; }
      if (page) { nf.setAttribute('data-mode', 'page'); var hd = q('.jfnc__head', nf); if (hd) { hd.remove(); } }
      if (nf.outerHTML === cur.outerHTML) { return; } /* Liquid je vec iscrtao to stanje (prvo osvjezavanje nakon ucitavanja): bez zamjene DOM-a */
      var a = d.activeElement, fk = a && a.getAttribute && a.getAttribute('data-jfnc-focus');
      var sc = q('.jfnc__scroll', cur), top = sc ? sc.scrollTop : 0, ul = q('[data-jfnc-up]', cur), ulx = ul ? ul.scrollLeft : 0;
      var cpv = q('.jfnc-cp__in', cur), cpval = cpv ? cpv.value : '';
      cur.replaceWith(nf);
      if (cpOpen) { var b = q('[data-jfnc-cp-toggle]', nf), body = q('.jfnc-cp__body', nf); if (b && body) { body.hidden = false; b.setAttribute('aria-expanded', 'true'); var inp = q('.jfnc-cp__in', nf); if (inp && cpval) { inp.value = cpval; } } }
      var nsc = q('.jfnc__scroll', nf); if (nsc) { nsc.scrollTop = top; }
      var nul = q('[data-jfnc-up]', nf); if (nul) { nul.scrollLeft = ulx; }
      var t = fk && q('[data-jfnc-focus="' + fk + '"]', nf);
      if (t) { t.focus(); } else if (isOpen && panel && !panel.contains(d.activeElement)) { (q('.jfnc__x', nf) || panel).focus({ preventScroll: true }); }
      if (!first) { first = nf; }
    });
    if (first) {
      var vis = parseInt(first.getAttribute('data-count'), 10) || 0;
      fire('jfn:cart:updated', { count: vis, item_count: vis, rawCount: parseInt(first.getAttribute('data-raw-count'), 10) || 0, total: parseInt(first.getAttribute('data-total'), 10) || 0, changed: changed });
      giftSync();
    }
    return true;
  }
  /* SPOOKY20 POKLON (13.10.2026.): Liquid (jfn-cart-fill) javlja data-gw = varijante koje kosarica treba imati kao poklon (kod SPOOKY20 + Saftkur)
     i data-gh = postojece _gift=spooky20 stavke (kljuc|varijanta|kolicina). Ovdje se samo uskladjuje: dodaj sto fali, makni visak, kolicina 1 ili treci dio zapisa (varijanta~oznaka~kolicina, OFFICE20 = 2).
     Najvise 2 pokusaja po istom stanju, pa nema petlje ako Shopify odbije dodavanje. */
  var gBusy = false, gTries = {}, gT;
  function giftSync() { clearTimeout(gT); gT = setTimeout(giftRun, 60); }
  function giftRun() {
    if (gBusy) { return; }
    var f = q('.jfnc__fill'); if (!f || !f.hasAttribute('data-gw')) { return; }
    var wtag = {}, wq = {}, want = (f.getAttribute('data-gw') || '').split(',').filter(Boolean).map(function (w) { var x = w.split('~'); wtag[x[0]] = x[1] || 'spooky20'; wq[x[0]] = parseInt(x[2], 10) || 1; return x[0]; }), hs = f.getAttribute('data-gh') || '';
    var up = {}, nUp = 0, got = {};
    hs.split(/\s+/).filter(Boolean).forEach(function (s) {
      var p = s.split('|'); if (p.length < 3) { return; }
      if (want.indexOf(p[1]) < 0 || got[p[1]]) { up[p[0]] = 0; nUp++; }
      else { got[p[1]] = 1; if (p[2] !== String(wq[p[1]])) { up[p[0]] = wq[p[1]]; nUp++; } }
    });
    var add = want.filter(function (v) { return !got[v]; });
    if (!nUp && !add.length) { return; }
    var sig = want.join(',') + '/' + hs;
    var gn = Date.now(), ge = gTries[sig]; if (!ge || gn - ge.t > 8000) { ge = gTries[sig] = { n: 0, t: gn }; } ge.n++; if (ge.n > 2) { return; }
    gBusy = true;
    /* 2.11.2026.: stanje se prije svakog dodavanja potvrdi iz /cart.js (DOM moze biti star): pokloni se nikad ne dodaju dvaput i uvijek su kolicine wq (x1) */
    cartJson().then(function (c) {
      var keys = {}, byV = {};
      (c.items || []).forEach(function (i) { keys[i.key] = 1; if (i.properties && i.properties._gift) { byV[String(i.variant_id)] = byV[String(i.variant_id)] || i; } });
      var up2 = {}, n2 = 0;
      Object.keys(up).forEach(function (k) { if (keys[k]) { up2[k] = up[k]; n2++; } });
      want.forEach(function (v) { var h = byV[v]; if (h && h.quantity !== wq[v] && up2[h.key] === undefined) { up2[h.key] = wq[v]; n2++; } });
      var add2 = add.filter(function (v) { return !byV[v]; });
      if (!n2 && !add2.length) { gBusy = false; refresh(); return null; }
      return (n2 ? call('cart/update.js', { updates: up2 }) : Promise.resolve(true)).then(function (j) {
        if (!j || !add2.length) { return j; }
        return call('cart/add.js', { items: add2.map(function (v) { return { id: parseInt(v, 10), quantity: wq[v] || 1, properties: { _gift: wtag[v] || 'spooky20' } }; }) });
      }).then(function (j) { gBusy = false; if (j && j !== true) { cartJson().then(announce).catch(function () {}); } if (j) { giftSync(); } }, function () { gBusy = false; });
    }, function () { gBusy = false; });
  }
  function fetchFill() {
    var sq = ++seq;
    return fetch(url('?sections=' + SECTION + '&_=' + Date.now()), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) { return { h: j && j[SECTION], sq: sq }; });
  }
  /* osvjezi sadrzaj; istodobni zahtjevi se skupljaju (najvise jedan u letu + jedan naknadni) */
  function refresh() {
    if (inflight) { again = true; return inflight; }
    inflight = fetchFill().then(function (o) { swap(o.h, o.sq); }).catch(function () {}).then(function () {
      inflight = null; busy(false); adding(false); pending = false;
      if (again) { again = false; return refresh(); }
    });
    return inflight;
  }
  function cartJson() { return fetch(url('cart.js'), { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function announce(cart) { selfEmit = true; try { fire('cart:updated', { cart: cart }); } finally { selfEmit = false; } }

  var ADD_RE = /\/cart\/add(\.js)?(\?|$)/;
  function withSections(init) {
    try {
      var body = init.body, h = init.headers || {}, ct = '';
      if (h.get) { ct = h.get('Content-Type') || ''; } else { Object.keys(h).forEach(function (k) { if (/content-type/i.test(k)) { ct = h[k]; } }); }
      var path = encodeURIComponent(location.pathname);
      if (typeof body === 'string') {
        if (/(^|&)sections=|"sections"/.test(body)) { return null; }
        if (/json/i.test(ct)) { var o = JSON.parse(body); o.sections = SECTION; o.sections_url = location.pathname; body = JSON.stringify(o); }
        else { body += (body ? '&' : '') + 'sections=' + SECTION + '&sections_url=' + path; }
      } else if (typeof FormData !== 'undefined' && body instanceof FormData) {
        if (body.has('sections')) { return null; }
        body.append('sections', SECTION); body.append('sections_url', location.pathname);
      } else { return null; }
      var n = {}; Object.keys(init).forEach(function (k) { n[k] = init[k]; }); n.body = body; return n;
    } catch (e) { return null; }
  }
  /* BRZINA (staging 13.10.): Fee Rules (Pfand) radi 3 koraka jedan za drugim: GET /apps/ss/.../product/<id> (~0,8 s) -> add Pfand (?ignorecheck, ~0,9 s) -> add proizvod (~1 s).
     1) odgovor /apps/ss se dohvaca unaprijed (ucitavanje + pointerdown) i sluzi iz memorije; 2) Pfand add se ne salje sam nego ide u ISTI zahtjev s proizvodom.
     Fee Rules odgovor Pfand adda ne cita; na checkoutu ionako radi verifyRules pa je to sigurnosna mreza ako nesto promakne. */
  var ssCache = {}, ssRe = /\/apps\/ss\/[^\/]+\/product\/(\d+)/, pfStash = null, pfT = 0, atcAt = 0;
  function ssWarm(vid) {
    if (!vid || ssCache[vid] || !window.Shopify || !Shopify.shop) { return; }
    ssCache[vid] = nativeFetch.call(window, '/apps/ss/' + Shopify.shop + '/product/' + vid, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) { throw 0; } return r.text(); }).catch(function () { delete ssCache[vid]; return null; });
  }
  function ssWarmPage() { qa('form[action*="/cart/add"] [name="id"]').slice(0, 24).forEach(function (i) { ssWarm(String(i.value || '')); }); }
  function jsonRes(o) { return new Response(JSON.stringify(o), { status: 200, headers: { 'Content-Type': 'application/json' } }); }
  function pfFlush() { clearTimeout(pfT); if (!pfStash) { return; } var it = pfStash; pfStash = null; nativeFetch.call(window, R + 'cart/add.js?ignorecheck=true', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: it }) }).then(function () { refresh(); }).catch(function () {}); }
  /* BF 1.11.2026.: 3 BF poklona idu u ISTI /cart/add zahtjev kao proizvod (prije: kosarica bez poklona -> giftSync add -> jos jedno iscrtavanje = sporo i treperi).
     giftSync ostaje kao sigurnosna mreza (vidi da su vec tu i ne radi nista). Do 30.11.2026. 23:59:59 Berlin. */
  var BF_GIFTS = ['57709186318709', '57709186351477', '57709186384245'];
  var BF_OPT = [
    ['\u00dcberraschung im Wert von 9 \u20ac', 900, 'https://cdn.shopify.com/s/files/1/0648/4217/0584/files/a05bb35a-c491-47ef-9dc7-e58f06e2adb4.jpg?v=1793532477'],
    ['Dein Ern\u00e4hrungsplan f\u00fcr 30 Tage', 1900, 'https://cdn.shopify.com/s/files/1/0648/4217/0584/files/a7e0bc6b-c23d-4f17-b252-97a2088ed4aa.jpg?v=1793532476'],
    ['Wellness-App (3 Monate Premium-Zugang gratis)', 2900, 'https://cdn.shopify.com/s/files/1/0648/4217/0584/files/a9c36fc6-f07a-43c0-8a84-0d146ada106b.jpg?v=1793532475']
  ];
  function bfMerge(init) {
    try {
      if (Date.now() > 1796079599000 || typeof init.body !== 'string' || !/^\s*\{/.test(init.body)) { return init; }
      var f = q('.jfnc__fill'), gh = f ? (f.getAttribute('data-gh') || '') : '';
      var miss = BF_GIFTS.filter(function (v) { return gh.indexOf('|' + v + '|') < 0; });
      if (!miss.length) { return init; }
      var ob = JSON.parse(init.body);
      if (!ob.items && ob.id) { ob.items = [{ id: ob.id, quantity: ob.quantity || 1, properties: ob.properties, selling_plan: ob.selling_plan }]; delete ob.id; delete ob.quantity; delete ob.properties; delete ob.selling_plan; }
      if (!ob.items || !ob.items.length) { return init; }
      var ids = ob.items.map(function (i) { return String(i.id); });
      if (ids.some(function (x) { return BF_GIFTS.indexOf(x) >= 0; })) { return init; }
      ob.items = ob.items.concat(miss.map(function (v) { return { id: parseInt(v, 10), quantity: 1, properties: { _gift: 'bf30' } }; }));
      var ni = {}; Object.keys(init).forEach(function (k) { ni[k] = init[k]; }); ni.body = JSON.stringify(ob); return ni;
    } catch (e) { return init; }
  }
  /* 2.11.2026.: kolekcije/quick-add (jfn-col.js, jf-saftkur-product-card) salju /cart/add.js kao FormData, pa se pokloni i Pfand nisu mogli spojiti u isti zahtjev
     (Pfand ide zasebno -> refresh s praznom kosaricom -> proizvod -> pokloni tek giftRun-om ~2 s kasnije = trzanje i rupa). Ovdje se jednostavan FormData (id, quantity, selling_plan,
     properties[x]) pretvara u JSON isti kao PDP; odgovor se vraca u starom obliku (jedna stavka + sections) da ostali slusaci ajaxProduct:added rade isto. */
  function fdToJson(init) {
    try {
      var fd = init.body; if (typeof FormData === 'undefined' || !(fd instanceof FormData) || fd.has('sections') || fd.has('items[0][id]')) { return null; }
      var o = { id: null, quantity: 1 }, props = {}, hasP = false, nId = 0, bad = false;
      fd.forEach(function (v, k) {
        var m;
        if (k === 'id') { nId++; o.id = parseInt(v, 10); }
        else if (k === 'quantity') { o.quantity = parseInt(v, 10) || 1; }
        else if (k === 'selling_plan') { if (v) { o.selling_plan = parseInt(v, 10) || v; } }
        else if ((m = k.match(/^properties\[(.+)\]$/))) { props[m[1]] = v; hasP = true; }
        else if (/^items\b/.test(k)) { bad = true; }
      });
      if (bad || nId !== 1 || !o.id) { return null; }
      if (hasP) { o.properties = props; }
      var h = {}; var src = init.headers || {};
      if (src.forEach) { src.forEach(function (v, k) { h[k] = v; }); } else { Object.keys(src).forEach(function (k) { h[k] = src[k]; }); }
      h['Content-Type'] = 'application/json'; if (!h.Accept && !h.accept) { h.Accept = 'application/json'; }
      var ni = {}; Object.keys(init).forEach(function (k) { ni[k] = init[k]; }); ni.body = JSON.stringify({ items: [o] }); ni.headers = h; return ni;
    } catch (e) { return null; }
  }
  function singleLine(pr) {
    return pr.then(function (res) {
      return res.clone().json().then(function (j) {
        if (!j || !j.items || !res.ok) { return res; }
        var one = {}; Object.keys(j.items[0] || {}).forEach(function (k) { one[k] = j.items[0][k]; }); if (j.sections) { one.sections = j.sections; }
        return new Response(JSON.stringify(one), { status: res.status, statusText: res.statusText, headers: { 'Content-Type': 'application/json' } });
      }).catch(function () { return res; });
    });
  }
  var jfnFetch = function (input, init) {
    var u = typeof input === 'string' ? input : (input && input.url) || '';
    var mth = (init && init.method) || 'GET', ss = /^get$/i.test(mth) && u.match(ssRe);
    if (init && /^post$/i.test(mth) && ADD_RE.test(u) && !call.own && u.indexOf('ignorecheck') < 0 && init.body && typeof init.body !== 'string') {
      var cj = fdToJson(init);
      if (cj) {
        var self = this, r0;
        try { r0 = jfnFetch.call(self, input, cj); } catch (e0) { r0 = null; }
        if (r0) {
          /* drawer se uvijek otvara s konacnim stanjem, neovisno o tome sto cita slusac odgovora */
          r0.then(function () { try { if (root && !isOpen) { pending = false; open(); } } catch (e1) {} }, function () {});
          return singleLine(r0);
        }
      }
    }
    if (ss && ssCache[ss[1]]) {
      return ssCache[ss[1]].then(function (t) { return t == null ? nativeFetch.call(window, input, init) : new Response(t, { status: 200, headers: { 'Content-Type': 'application/json' } }); });
    }
    if (ss) { ssWarm(ss[1]); var w = ssCache[ss[1]]; if (w) { return w.then(function (t) { return t == null ? nativeFetch.call(window, input, init) : new Response(t, { status: 200, headers: { 'Content-Type': 'application/json' } }); }); } }
    if (/^post$/i.test(mth) && /\/cart\/add\.js\?ignorecheck=true/.test(u) && Date.now() - atcAt < 6000 && init && typeof init.body === 'string') {
      try { var pb = JSON.parse(init.body); if (pb && pb.items && pb.items.length) { pfStash = (pfStash || []).concat(pb.items); clearTimeout(pfT); pfT = setTimeout(pfFlush, 2500); return Promise.resolve(jsonRes({ items: [] })); } } catch (e) {}
    }
    if (pfStash && init && /^post$/i.test(mth) && ADD_RE.test(u) && u.indexOf('ignorecheck') < 0) {
      var merged = false;
      try { if (typeof init.body === 'string' && /^\s*\{/.test(init.body)) { var ob = JSON.parse(init.body); if (ob.items) { ob.items = ob.items.concat(pfStash); } else if (ob.id) { ob.items = [{ id: ob.id, quantity: ob.quantity || 1, properties: ob.properties, selling_plan: ob.selling_plan }].concat(pfStash); delete ob.id; delete ob.quantity; delete ob.properties; delete ob.selling_plan; } if (ob.items) { var ni = {}; Object.keys(init).forEach(function (k) { ni[k] = init[k]; }); ni.body = JSON.stringify(ob); init = ni; merged = true; } } } catch (e) {}
      if (merged) { clearTimeout(pfT); pfStash = null; } else { pfFlush(); }
    }
    if (init && init.method && /^post$/i.test(init.method) && ADD_RE.test(u) && !call.own && u.indexOf('ignorecheck') < 0) {
      init = bfMerge(init);
      var n = withSections(init);
      if (n) {
        var sq = ++seq, pr = nativeFetch.call(this, input, n);
        addFill = pr.then(function (res) { return res.clone().json(); }).then(function (j) {
          if (j && j.sections && j.sections[SECTION]) { swap(j.sections[SECTION], sq); fillAt = Date.now(); return true; }
          return false;
        }).catch(function () { return false; });
        return pr;
      }
    }
    return nativeFetch.apply(this, arguments);
  };
  window.fetch = jfnFetch;

  function call(endpoint, body, raw) {
    body.sections = SECTION; body.sections_url = location.pathname;
    var job = queue.then(function () {
      busy(true);
      var sq = ++seq;
      call.own = true;
      var req = (raw ? nativeFetch : fetch).call(window, url(endpoint), { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      call.own = false;
      return req
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          busy(false);
          var j = res.j || {};
          if (!res.ok || j.status === 422 || j.status === 400 || j.errors) {
            toast(j.description || j.message || (typeof j.errors === 'string' ? j.errors : tr('err')));
            return refresh().then(function () { return null; });
          }
          if (j.sections && j.sections[SECTION]) { swap(j.sections[SECTION], sq); } else { refresh(); }
          return j;
        })
        .catch(function () { busy(false); toast(tr('err')); return refresh().then(function () { return null; }); });
    });
    queue = job.catch(function () {});
    return job;
  }

  function restoring(fn) {
    html.classList.add('jf-scroll-restoring');
    var sb = html.style.scrollBehavior; html.style.scrollBehavior = 'auto';
    try { fn(); } finally { html.style.scrollBehavior = sb; requestAnimationFrame(function () { requestAnimationFrame(function () { html.classList.remove('jf-scroll-restoring'); }); }); }
  }
  function guard(e) {
    if (!isOpen) { return; }
    var sc = q('.jfnc__scroll', panel), t = e.target;
    var ft = t && t.closest && t.closest('.jfnc__foot');
    if (ft && panel.contains(ft) && ft.scrollHeight > ft.clientHeight + 1) { return; }
    if (sc && sc.contains(t)) {
      if (e.type === 'wheel' && ((e.deltaY < 0 && sc.scrollTop <= 0) || (e.deltaY > 0 && sc.scrollTop + sc.clientHeight >= sc.scrollHeight - 1))) { if (e.cancelable) { e.preventDefault(); } }
      return;
    }
    if (e.cancelable) { e.preventDefault(); }
  }
  /* 1.11.2026: iOS nakon tipkovnice (kod) ostavi window pomaknut dok je body fixed, pa skrol kosarice zapne */
  d.addEventListener('focusout', function (e) {
    if (!isOpen || !IOS) { return; }
    var t = e.target; if (!t || !t.closest || !t.closest('.jfnc')) { return; }
    setTimeout(function () { var a = d.activeElement; if (a && a.tagName && /input|textarea/i.test(a.tagName)) { return; } if (window.scrollY) { window.scrollTo(0, 0); } }, 60);
  }, true);
  d.addEventListener('wheel', guard, { passive: false });
  d.addEventListener('touchmove', guard, { passive: false });
  function focusables() { return qa('button:not([disabled]),a[href],input:not([disabled]),[tabindex]:not([tabindex="-1"])', panel).filter(function (e) { return e.offsetParent !== null; }); }
  function open() {
    if (!root) { location.href = url('cart'); return; }
    if (isOpen) { return; }
    last = d.activeElement; isOpen = true;
    root.hidden = false;
    html.style.setProperty('--jfnc-sbw', Math.max(0, window.innerWidth - html.clientWidth) + 'px');
    lockY = window.scrollY || 0;
    restoring(function () {
      html.classList.add('jfnc-lock'); d.body.classList.add('jfnc-lock');
      if (IOS) { var bs = d.body.style; bs.position = 'fixed'; bs.top = (-lockY) + 'px'; bs.left = '0'; bs.right = '0'; bs.width = '100%'; }
    });
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { root.classList.add('is-open'); var x = q('.jfnc__x', panel); (x || panel).focus({ preventScroll: true }); });
    });
    if (!pending && Date.now() - lastSync > 2000) { refresh(); } /* kosarica je mogla biti promijenjena u drugom tabu */
    fire('jfn:cart:opened');
  }
  function unlockBody() { var bs = d.body.style; if (bs.position !== 'fixed') { return; } bs.position = bs.top = bs.left = bs.right = bs.width = ''; window.scrollTo(0, lockY); }
  function close() {
    if (!isOpen) { return; }
    isOpen = false; pending = false; clearTimeout(pendingT); btnLoad(false);
    root.classList.remove('is-open');
    restoring(function () { html.classList.remove('jfnc-lock'); d.body.classList.remove('jfnc-lock'); unlockBody(); });
    /* safety net: scroll se uvijek vraca na mjesto gdje je korisnik dodao (+-5 px), osim ako drugi modal drzi lock */
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      if (isOpen || d.body.classList.contains('jfnc-lock') || d.body.style.position === 'fixed') { return; }
      if (Math.abs((window.scrollY || 0) - lockY) > 5) { var sb2 = html.style.scrollBehavior; html.style.scrollBehavior = 'auto'; window.scrollTo(0, lockY); html.style.scrollBehavior = sb2; }
    }); });
    setTimeout(function () { if (!isOpen) { root.hidden = true; } }, reduce ? 0 : 380);
    if (last && last.focus) { last.focus({ preventScroll: true }); }
    fire('jfn:cart:closed');
  }

  function lineKeys(it) { return (it.getAttribute('data-keys') || it.getAttribute('data-key') || '').split(/\s+/).filter(Boolean); }
  function removeLine(it) {
    var keys = lineKeys(it);
    /* 2.11.2026.: redak nestaje ODMAH (display:none + preracun iznosa u UI-ju); ako je to zadnji placeni proizvod, pokloni i Pfand idu van u ISTOM zahtjevu; jedan odgovor = jedan render; ako zahtjev padne, redak se vraca. */
    var fill = it.closest('.jfnc__fill'), rest = fill ? qa('.jfnc-ci', fill).filter(function (r) { return r !== it && !r.classList.contains('is-gift') && !r.classList.contains('jfnc-ci--opt') && r.style.display !== 'none'; }) : [1];
    var gifts = (fill && !rest.length) ? qa('.jfnc-ci.is-gift', fill) : [];
    gifts.forEach(function (g) { keys = keys.concat(lineKeys(g)); });
    var feeK = (!rest.length && fill) ? (fill.getAttribute('data-fee') || '').split(/\s+/).filter(Boolean) : [];
    keys = keys.concat(feeK);
    var hidden = [it].concat(gifts);
    hidden.forEach(function (r) { r.setAttribute('data-rm', '1'); r.style.display = 'none'; });
    try { optTotal(fill, it, !rest.length); } catch (e) {}
    var up0 = keys.reduce(function (o, k) { o[k] = 0; return o; }, {});
    function restore() { hidden.forEach(function (r) { r.style.display = ''; r.removeAttribute('data-rm'); }); refresh(); }
    /* zadnji placeni proizvod: mimo Fee Rules omotaca (jedan zahtjev); inace Fee Rules uskladi Pfand ostalih proizvoda */
    return call('cart/update.js', { updates: up0 }, !rest.length).then(function (j) {
      if (!j) { restore(); return; }
      say(tr('removed')); announce(j);
    });
  }
  /* trenutni preracun iznosa pri micanju: oduzmi cijenu retka (i pokloni/Pfand ako je zadnji) od prikazanog; pravi iznos stize s odgovorom */
  function optTotal(fill, it, last) {
    if (!fill) { return; }
    var tot = q('[data-jfnc-total]', fill); if (!tot) { return; }
    var txt = tot.textContent, m = txt.match(/(\d{1,3}(?:[.\s]\d{3})*|\d+),(\d{2})/); if (!m) { return; }
    var cur = Math.round(parseInt(m[1].replace(/[.\s]/g, ''), 10) * 100 + parseInt(m[2], 10));
    var pe = q('.jfnc-ci__price ins, .jfnc-ci__price > span:last-child', it) || q('.jfnc-ci__price', it), pm = pe && pe.textContent.match(/(\d{1,3}(?:[.\s]\d{3})*|\d+),(\d{2})/);
    var sub = pm ? Math.round(parseInt(pm[1].replace(/[.\s]/g, ''), 10) * 100 + parseInt(pm[2], 10)) : 0;
    var nc = last ? 0 : Math.max(0, cur - sub);
    tot.textContent = txt.replace(m[0], (Math.floor(nc / 100)).toLocaleString('de-DE') + ',' + ('0' + (nc % 100)).slice(-2));
  }
  function setQty(it, n) {
    var keys = lineKeys(it);
    var p;
    if (keys.length > 1) { // bundle: sve stavke grupe se skaliraju proporcionalno (kao ed-bundle-amount)
      var base = parseInt(it.getAttribute('data-qty'), 10) || 1, map = {};
      (it.getAttribute('data-qtys') || '').split(/\s+/).forEach(function (kv) { var i = kv.lastIndexOf(':'); if (i > 0) { map[kv.slice(0, i)] = parseInt(kv.slice(i + 1), 10) || 0; } });
      var up = {}; keys.forEach(function (k) { up[k] = Math.max(0, Math.round((map[k] || base) * n / base)); });
      p = call('cart/update.js', { updates: up });
    } else { p = call('cart/change.js', { id: keys[0], quantity: n }); }
    return p.then(function (j) { if (j) { say(tr('qty')); announce(j); } });
  }
  function step(btn) {
    var it = btn.closest('.jfnc-ci'), inp = q('.jfnc-q__i', it), n = (parseInt(inp.value, 10) || 1) + parseInt(btn.getAttribute('data-jfnc-q'), 10);
    if (n < 1) { return removeLine(it); }
    var o = parseInt(inp.value, 10) || 1;
    inp.value = n; var k = it.getAttribute('data-key');
    /* 1.11.2026.: cijena retka se odmah preracuna (ne ceka Shopify + Fee Rules ~1 s) */
    try { qa('.jfnc-ci__price ins, .jfnc-ci__price del, .jfnc-ci__price > span', it).forEach(function (el) {
      if (el.children.length) { return; }
      var t = el.textContent, m = t.match(/(\d{1,3}(?:[.\s]\d{3})*|\d+),(\d{2})/); if (!m) { return; }
      var c = Math.round(parseInt(m[1].replace(/[.\s]/g, ''), 10) * 100 + parseInt(m[2], 10)), nc = Math.round(c * n / o);
      var nt = (Math.floor(nc / 100)).toLocaleString('de-DE') + ',' + ('0' + (nc % 100)).slice(-2);
      el.textContent = t.replace(m[0], nt);
    }); } catch (e) {}
    clearTimeout(timers[k]); timers[k] = setTimeout(function () { setQty(it, n); }, 250);
  }
  function codes(f) { return (f && f.getAttribute('data-codes') || '').split(',').filter(Boolean); }
  function currentCodes() { var f = q('.jfnc__fill'); return codes(f); }
  function discountCall(list) { return call('cart/update.js', { discount: list.join(',') }); }
  function coupon(form) {
    var v = form.elements.coupon.value.trim(), err = q('.jfnc-cp__err', form.parentNode);
    err.hidden = true;
    if (!v) { return; }
    var prev = currentCodes();
    discountCall(prev.concat([v])).then(function (j) {
      if (!j) { return; }
      var list = j.discount_codes || [], hit = list.filter(function (c) { return c.code && c.code.toLowerCase() === v.toLowerCase(); })[0];
      if (hit && hit.applicable === false || !hit) {
        discountCall(prev).then(function () { var e = q('.jfnc-cp__err'); if (e) { e.textContent = tr('codeErr'); e.hidden = false; } });
        return;
      }
      cpOpen = false; try { var ae = d.activeElement; if (ae && ae.blur) { ae.blur(); } } catch (x) {}
      say(tr('codeOk')); announce(j);
    });
  }
  function removeCode(code) {
    discountCall(currentCodes().filter(function (c) { return c.toLowerCase() !== String(code).toLowerCase(); })).then(function (j) { if (j) { say(tr('codeRm')); announce(j); } });
  }
  function addUpsell(btn) {
    var id = parseInt(btn.getAttribute('data-jfnc-add'), 10), pf = btn.getAttribute('data-pfand') || 'false';
    if (btn.classList.contains('is-loading')) { return; }
    /* 2.11.2026.: odmah loading stanje na gumbu (dimenzije se ne mijenjaju), jedan zahtjev (Fee Rules Pfand se spaja u isti), jedan render, skrol drawera ostaje */
    var sc = q('.jfnc__scroll', panel), top = sc ? sc.scrollTop : 0;
    btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); btn.style.pointerEvents = 'none';
    return call('cart/add.js', { items: [{ id: id, quantity: 1, properties: { _upsell_product_id: String(id), _pfand: pf } }] }).then(function (j) {
      var nsc = q('.jfnc__scroll', panel); if (nsc && top) { nsc.scrollTop = top; }
      if (!j) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); btn.style.pointerEvents = ''; return; }
      say(tr('added')); announce(j);
    });
  }
  /* javni add: za PDP/ostale agente. payload = {items:[...]} | {id,quantity,properties,selling_plan} | FormData */
  function add(payload) {
    var body;
    if (typeof FormData !== 'undefined' && payload instanceof FormData) {
      body = {}; payload.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m) { (body.properties = body.properties || {})[m[1]] = v; } else { body[k] = v; } });
      if (body.id) { body.id = parseInt(body.id, 10); }
      if (body.quantity) { body.quantity = parseInt(body.quantity, 10); }
    } else { body = JSON.parse(JSON.stringify(payload)); }
    open();
    return call('cart/add.js', body).then(function (j) {
      pending = false; clearTimeout(pendingT);
      if (!j) { return null; }
      selfAdded = true; try { fire('ajaxProduct:added', { product: j.items ? j.items[0] : j, addToCartBtn: null }); } finally { selfAdded = false; }
      return j;
    });
  }

  function reveal(card) {
    var sc = card && card.closest('.jfnc__scroll');
    if (!sc || sc.scrollHeight <= sc.clientHeight) { return; }
    var c = card.getBoundingClientRect(), r = sc.getBoundingClientRect(), dy = 0;
    if (c.bottom > r.bottom) { dy = c.bottom - r.bottom + 12; } else if (c.top < r.top) { dy = c.top - r.top - 12; }
    if (dy) { sc.scrollTo({ top: sc.scrollTop + dy, behavior: reduce ? 'auto' : 'smooth' }); }
  }
  d.addEventListener('click', function (e) {
    var t = e.target, el;
    if (!t.closest) { return; }
    if (!t.closest('[data-jfnc-root]')) {
      el = t.closest('.js-drawer-open-cart,[data-jfnc-open],a[href$="/cart"]');
      if (el && !(e.ctrlKey || e.metaKey || e.shiftKey || e.button === 1)) {
        e.preventDefault();
        if (q('[data-jfnc-root][data-jfnc-mode="page"]')) { window.scrollTo({ top: 0 }); } else { open(); }
      }
      return;
    }
    if (t.closest('[data-jfnc-close]')) { close(); return; }
    if ((el = t.closest('[data-jfnc-q]'))) { return step(el); }
    if ((el = t.closest('[data-jfnc-rm]'))) { return removeLine(el.closest('.jfnc-ci')); }
    if ((el = t.closest('[data-jfnc-cp-toggle]'))) {
      var b = q('.jfnc-cp__body', el.parentNode), on = b.hidden;
      b.hidden = !on; cpOpen = on; el.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) { q('.jfnc-cp__in', b).focus(); }
      return;
    }
    if ((el = t.closest('[data-jfnc-cp-rm]'))) { return removeCode(el.getAttribute('data-jfnc-cp-rm')); }
    if ((el = t.closest('[data-jfnc-add]'))) { return addUpsell(el); }
    if ((el = t.closest('[data-jfnc-up-nav]'))) {
      var l = q('[data-jfnc-up]', el.closest('.jfnc-up'));
      l.scrollBy({ left: parseInt(el.getAttribute('data-jfnc-up-nav'), 10) * l.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      setTimeout(function () {
        var cards = qa('.jfnc-upc', l), cur = cards.reduce(function (a, c) { return Math.abs(c.offsetLeft - l.offsetLeft - l.scrollLeft) < Math.abs(a.offsetLeft - l.offsetLeft - l.scrollLeft) ? c : a; }, cards[0]);
        if (cur) { reveal(cur); }
      }, reduce ? 0 : 380);
    }
  });
  d.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.matches && f.matches('[data-jfnc-cp-form]')) { e.preventDefault(); coupon(f); return; }
    /* stari Impulse ATC (PDP, kolekcije): otvori odmah (optimisticki), sadrzaj stize s ajaxProduct:added */
    if (f.matches && f.matches('form[action*="/cart/add"]')) { atcAt = Date.now(); }
    if (f.matches && f.matches('form[action*="/cart/add"]') && root && !f.closest('[data-jfnc-root]') && !q('[data-jfnc-root][data-jfnc-mode="page"]')) {
      btnLoad(true, e.submitter || q('[type="submit"],button[name="add"]', f));
      pending = true; /* tezak rad (otvaranje, skrol-lock) tek nakon sto stari ATC postavi stanje gumba: reakcija gumba ostaje < 100 ms */
      requestAnimationFrame(function () { if (pending) { open(); adding(true); optimistic(f); } });
      clearTimeout(pendingT); pendingT = setTimeout(function () { if (pending) { refresh(); } }, 7000);
    }
  }, true);
  d.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.matches || !t.matches('[data-jfnc-qty]')) { return; }
    var it = t.closest('.jfnc-ci'), n = parseInt(t.value, 10);
    if (!n || n < 1) { return removeLine(it); }
    setQty(it, n);
  });
  d.addEventListener('keydown', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-jfnc-qty]') && e.key === 'Enter') { e.preventDefault(); t.blur(); return; }
    if (!isOpen) { return; }
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = focusables(); if (!f.length) { return; }
      var a = f[0], z = f[f.length - 1];
      if (!panel.contains(d.activeElement)) { e.preventDefault(); a.focus(); }
      else if (e.shiftKey && (d.activeElement === a || d.activeElement === panel)) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && d.activeElement === z) { e.preventDefault(); a.focus(); }
      return;
    }
    if ([' ', 'PageUp', 'PageDown', 'Home', 'End', 'ArrowUp', 'ArrowDown'].indexOf(e.key) < 0) { return; }
    var tag = t && t.tagName ? t.tagName.toLowerCase() : '';
    if (panel && panel.contains(t) && (tag === 'input' || tag === 'textarea' || tag === 'select' || tag === 'button' || tag === 'a')) { return; }
    var sc = q('.jfnc__scroll', panel);
    if (sc && sc.contains(t)) { return; }
    e.preventDefault();
  });

  d.addEventListener('ajaxProduct:added', function () {
    if (selfAdded) { return; }
    pending = false; clearTimeout(pendingT);
    if (q('[data-jfnc-root][data-jfnc-mode="page"]')) { location.reload(); return; }
    open();
    if (addFill) { addFill.then(function (ok) { if (!ok) { refresh(); } else { busy(false); adding(false); } }); } else { refresh(); }
    addFill = null;
  });
  d.addEventListener('ajaxProduct:error', function () { if (pending) { pending = false; clearTimeout(pendingT); busy(false); adding(false); close(); } });
  d.addEventListener('cart:open', open);
  d.addEventListener('cart:close', close);
  /* cart:build (Pfand skripta, box-builder, ?open_cart=1 petlja): osvjezi uvijek, ali nakon 2 uzastopna "bez promjene" 3 s ignoriraj (petlja salje 25x) */
  d.addEventListener('cart:build', function () {
    if (Date.now() < buildMute) { return; }
    refresh().then(function () { if (lastChanged) { idle = 0; } else if (++idle >= 2) { buildMute = Date.now() + 3000; idle = 0; } });
  });
  d.addEventListener('cart:updated', function (e) {
    if (selfEmit) { return; }
    var c = e.detail && e.detail.cart, f = q('.jfnc__fill');
    if (c && f && c.total_price === (parseInt(f.getAttribute('data-total'), 10) || 0) && c.item_count === (parseInt(f.getAttribute('data-raw-count'), 10) || 0) && !inflight) { return; }
    refresh();
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { refresh(); } });

  function init() {
    root = q('[data-jfnc-root][data-jfnc-mode="drawer"]');
    panel = root && q('.jfnc__panel', root);
    var f = q('.jfnc__fill'); if (f) { lastSync = Date.now(); giftSync(); }
    var qs = new URLSearchParams(location.search);
    if (root && (qs.get('cart') === 'open' || qs.get('open_cart') === '1')) { open(); }
  }
  window.jfnCart = { v: 1, open: open, close: close, refresh: refresh, add: add, count: function () { var f = q('.jfnc__fill'); return f ? parseInt(f.getAttribute('data-count'), 10) || 0 : 0; } };
  if (d.readyState === 'loading') { d.addEventListener('DOMContentLoaded', init); } else { init(); }
}());
